import PropTypes from 'prop-types'
import { CustomInputWrapper } from '../../styled'
import { OptionLabel } from '../styles'

function RadioInput({ value, onChange }) {
  return (
    <div className="mt-2">
      {['Yes', 'No'].map((opt) => (
        <CustomInputWrapper
          key={opt}
          checked={value === opt}
          onClick={() => onChange(opt)}
        >
          <input
            type="radio"
            checked={value === opt}
            onChange={() => {}} // Handled by wrapper
          />
          <OptionLabel>{opt}</OptionLabel>
        </CustomInputWrapper>
      ))}
    </div>
  )
}

RadioInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default RadioInput
